import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageDialogComponent } from './messagedialog/messagedialog.component';
import { MatModule } from '../mat.module';

@NgModule({
    declarations: [MessageDialogComponent],
    imports: [CommonModule, MatModule],
    providers: []
})
export class MessageBoxModule {}
